import { useFliptFeature, type FliptFeature } from "~/hooks/useFliptFeature";
import { FLIPT_ROUTE_KEYS } from "~/router/constants";

/**
 * Flipt `ai-evals-dashboard`, gating the admin Evals tab — its sidebar entry and
 * its routes. Rolled out to the AI team on manifold stage while the dashboard is
 * still being shaped; `admin:agents` remains the permission gate underneath.
 */
export const useEvalsDashboardFeature = (): FliptFeature =>
  useFliptFeature(FLIPT_ROUTE_KEYS.AI_EVALS_DASHBOARD);
